import { MatchingContext } from '../path-pattern.ts';

/*internal*/ export abstract class PathElement {
    protected static readonly WILDCARD_WEIGHT = 100;
    protected static readonly CAPTURE_VARIABLE_WEIGHT = 1;

    protected static readonly NO_PARAMETERS: Map<string, readonly string[]> = new Map();

    // position in the pattern where this path element starts
    protected readonly pos: number;
    // the separator used in this path pattern
    protected readonly separator: number;

    // the next path element in the chain
    /*protected*/ next?: PathElement;
    // the previous path element in the chain
    /*protected*/ prev?: PathElement;

    /*internal*/ protected constructor(pos: number, separator: number) {
        this.pos = pos;
        this.separator = separator;
    }

    abstract matches(candidatePos: number, matchingContext: MatchingContext): boolean;

    abstract get normalizedLength(): number;

    abstract get chars(): Uint16Array;

    get captureCount(): number {
        return 0;
    }

    get wildcardCount(): number {
        return 0;
    }

    get score(): number {
        return 0;
    }

    get literal() {
        return false;
    }

    /*protected final*/
    noMorePattern() {
        return this.next === undefined;
    }

}
